import type React from 'react';
import { FileDetailsModal, Modal, Skeleton } from 'shared-portal-components-v2';

import { useFileDetailModal } from '@/hooks/fileDetail/useFileDetailModal';

function FileDetailModalContainer(): React.JSX.Element | null {
  const { state, handlers } = useFileDetailModal();

  if (!state.isOpen) return null;

  if (state.fileDetailPayload === undefined) {
    return (
      <Modal isOpen onClose={handlers.handleClose} title="File Details" panelClassName="max-w-lg w-full">
        <div className="flex flex-col gap-4 p-6">
          <Skeleton className="h-6 w-3/4" shape="text" />
          <Skeleton className="h-4 w-1/2" shape="text" />
          <Skeleton className="h-32 w-full" shape="rect" />
          <Skeleton className="h-4 w-2/3" shape="text" />
          <Skeleton className="h-4 w-1/3" shape="text" />
        </div>
      </Modal>
    );
  }

  return (
    <FileDetailsModal
      open={state.isOpen}
      onOpenChange={handlers.handleOpenChange}
      data={state.fileDetailPayload}
      isFavorited={state.isFavorited}
      onToggleFavorite={handlers.handleToggleFavorite}
      onDownload={handlers.handleDownload}
    />
  );
}

export default FileDetailModalContainer;
